import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mtdashboard',
  templateUrl: './mtdashboard.component.html',
  styleUrls: ['./mtdashboard.component.scss']
})
export class MtdashboardComponent implements OnInit {
  mentorcourse!: FormGroup;
  mentorcourse_motivational!: FormGroup;
  user_activity_id: any;
  district: any = this.ApiService.district;
  constituency: any = this.ApiService.constituency;
  user_district: any = this.ApiService.user_details.district;
  user_constituency: any = this.ApiService.user_details.constituency;

  count_activity: any;
  courses_assigned_to: any;

  
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;

  districtname: any;
  users = JSON.parse(localStorage.getItem('login_user_details'));
  permanent_token =JSON.parse(localStorage.getItem('permanent_token'));
  constructor(
    private fb: FormBuilder,
    private ApiService: ApiServiceService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    console.log(this.ApiService);
    this.mentorcourse = this.fb.group({
   
      course_name: ['',Validators.required],
      typeofcourse: ['Technical'],
      course_topic: ['',Validators.required],
      user_id: this.users.id,
      student_id:[''],
      course_des: [''],
      course_date: ['',Validators.required],
      course_time: ['',Validators.required],
      session_link: ['',Validators.required],
      image:['',[this.imageSizeValidator(60000)]],
      mode: ['Online', Validators.required],
      comments: ['']
    });
    this.mentorcourse_motivational = this.fb.group({
   
      course_name: ['',Validators.required],
      course_topic: [''],
      typeofcourse: ['Career Guidance'],
      user_id: this.userId,
      student_id:[''],
      course_des: [''],
      course_date: ['',Validators.required],
      course_time: ['',Validators.required],
      session_link: ['',Validators.required],
      image:['',[this.imageSizeValidator(60000)]],
      mode: ['Online', Validators.required],
      comments: ['']
    });
    console.log('mentorcourse_motivational', this.mentorcourse_motivational);
    console.log('mentorcourse_motivational', this.mentorcourse);
    
  }

  user_name: any = this.ApiService.user_details.firstname;
  user_id: any = this.ApiService.user_details.id;
  upcoming_course_count:any;
  completed_course_count:any;
  ngOnInit(): void {
    this.districtname = JSON.parse(localStorage.getItem('user_district'));
   this.users = JSON.parse(localStorage.getItem('login_user_details'));
    console.log(this.users.id);
    console.log(this.districtname);

    // this.ApiService.courseAssignedToMentor(this.users.id).subscribe((data: any) => {
    //   console.log(data,"sknsdnjs");
    //   this.courses_assigned_to = data.length;
    // });
    // this.ApiService.mentor_dashboard(this.users.id,this.permanent_token).subscribe({
    //   next: (data: any) => {
    
    //     console.log('devi',data);
    //     // Initialize counters
    //     this.upcoming_course_count = data.upcoming_course_count
    //     this.completed_course_count =data.completed_course_count;
    
    //     // Count upcoming and completed courses
       
    
    //     // Output counts
    //     console.log("Upcoming Courses Count:", this.upcoming_course_count);
    //     console.log("Completed Courses Count:", this.completed_course_count);
    //   }
    // });
    this.ApiService.get_courese_byuserId(this.users.id).subscribe({
      next: (data: any) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize the time part to 00:00:00
    
        // Initialize counters
        this.upcoming_course_count = 0;
        this.completed_course_count = 0;
    
        // Count upcoming and completed courses
        data.course.forEach((course: any) => {
          const courseDate = new Date(course.course_date);
          courseDate.setHours(0, 0, 0, 0); // Normalize the time part to 00:00:00
    
          // Debugging outputs
          console.log(courseDate, 'courseDate');
          console.log('today', today);
    
          if (courseDate >= today) {
            // Course is upcoming (today or later)
            this.upcoming_course_count++;
          } else {
            // Course is completed (before today)
            this.completed_course_count++;
          }
        });
    
        // Output counts
        console.log("Upcoming Courses Count:", this.upcoming_course_count);
        console.log("Completed Courses Count:", this.completed_course_count);
      }
    });
  }

  uploadFiles: any = '';

  selectFiles(event: any) {
    if (event.target.files[0].size < 60000) {
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "The size should be less than 60kb",
        showConfirmButton: false,
        timer: 1500
      });
      $('#file').val('');
      // Mark the 'image' form control as invalid
      this.mentorcourse.get('image')?.setErrors({ 'imageSizeExceeded': true });
    }
  }
  imageSizeValidator(maxSize: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && control.value.size) {
        const fileSize = control.value.size; // Get the size of the file
        if (fileSize > maxSize) {
          return { 'imageSizeExceeded': true }; // Return an error if the size exceeds the limit
        }
      }
      return null; // Return null if the size is within the limit
    };
  }

  current_date: any;
  current_time: any;
  getCurrentDates(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()+1).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Function to get the current time in the format HH:MM
  getCurrentTime(): string {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  setCurrentdate() {
    this.current_date = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time = this.datepipe.transform(new Date(), 'HH:mm');
    this.mentorcourse.get('district').setValue(this.userDistrict);
    this.mentorcourse.get('constituency').setValue(this.userConstituency);
    this.mentorcourse.get('user_id').setValue(this.userId);
  }

  public showSpinner(): void {
    this.spinnerService.show();
  }

  postdata(data:any)
  {
    console.log(data.value);
    data.value['image'] = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';

    this.ApiService.createMentorcourse(data.value).pipe().subscribe(
      data => {
        console.log(data);
        // this.spinnerService.hide();
      
        setTimeout(function () {
          Swal.fire({
            title: "Course has been created Successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor:'#015792',
            iconColor: "#015792" // Set the icon color here
          }).then(() => {
            window.location.reload();
            this.mentorcourse.reset();
          });
        }, 100);
      },
      
        
        error => {
          console.log(error);
        });
  }

  postdata_motivation(motivationaldata:any){
    console.log(motivationaldata);
    motivationaldata['image'] = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';

    //motivationaldata.user_id=this.users.id;
    this.ApiService.createMentorcourse(motivationaldata.value).pipe().subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
      
        setTimeout(function () {
          Swal.fire({
            title: "Career Guidance has been created Successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor:'#015792',
            iconColor: "#015792" // Set the icon color here
          }).then(() => {
            window.location.reload();
            this.mentorcourse.reset();
          });
        }, 100);
      },
      
        
        error => {
          console.log(error);
        });
  }
 


 

  Formreset() {
    this.mentorcourse.reset();
    this.mentorcourse_motivational.reset();
    // this.hidden = true;
    // this.MeetingOptions = '';
  }
}